import React, { useState, useEffect } from "react";
import styles from "./Hero.module.css";
import {
  FaRocket,
  FaArrowRight,
  FaUsers,
  FaGlobe,
  FaLaptopCode,
  FaUserGraduate,
} from "react-icons/fa";

const Hero = () => {
  const [isWideScreen, setIsWideScreen] = useState(window.innerWidth > 768);

  useEffect(() => {
    const handleResize = () => {
      setIsWideScreen(window.innerWidth > 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const quickStats = [
    { icon: <FaUsers />, value: "1.2 Lakh+", label: "Happy Children" },
    { icon: <FaGlobe />, value: "120+", label: "Mentors" },
    { icon: <FaLaptopCode />, value: "240+", label: "Schools" },
    { icon: <FaUserGraduate />, value: "7+ Cities", label: "across India" },
  ];
  const handleDemoClick = () => {
    const formElement = document.getElementById("cta-form");
    if (formElement) {
      formElement.scrollIntoView({ behavior: "smooth" });
    }
  };
  return (
    <div className={styles.hero}>
      <div className={styles.content}>
        <div className={styles.mainContent} data-aos="fade-up">
          <h1 data-aos="fade-up" data-aos-delay="100">
            Konnichiwa! {isWideScreen && <br />}
            Kick-start your School with
            <span
              className={styles.highlight}
              data-aos="fade-up"
              data-aos-delay="150"
            >
              {" "}
              Japanese curriculum through STEM learning.
            </span>
          </h1>
          <p data-aos="fade-up" data-aos-delay="200">
            STEMx India supported by MiCHiTECH, a Japanese venture under the KTC
            Group offers world class STEM hardware, curriculum, and trainers in
            line with your objectives to deliver 21st Century skills.
          </p>
          <div
            className={styles.buttons}
            data-aos="fade-up"
            data-aos-delay="300"
          >
            <button className={styles.primary}>
              <a
                href="https://youtu.be/oG4c-76EF-I?si=jLLCwdVcLzrPeKs-"
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: "none", color: "white" }}
              >
                Watch Video <FaRocket className={styles.icon} />
              </a>
            </button>
            <button className={`${styles.secondary}`} onClick={handleDemoClick}>
              <div className={styles.button_content}>
                {" "}
                Request Demo <FaArrowRight className={styles.icon} />
              </div>
            </button>
            <span className={styles.buttoninfo}>
              *For Schools & Channel Partners only
            </span>
          </div>
        </div>
      </div>

      <div className={styles.statsGrid}>
        {quickStats.map((stat, index) => (
          <div key={index} className={styles.quickStat}>
            <div className={styles.statIcon}>{stat.icon}</div>
            <div className={styles.statValue}>{stat.value}</div>
            <div className={styles.statLabel}>{stat.label}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Hero;
